import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = ["src"]

import DividerHorizontal from '@/design-system/atoms/DividerHorizontal.vue'
import TextBase, { Props as TextBaseProps } from '@/design-system/atoms/TextBase.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import ButtonSecondary from '@/design-system/atoms/buttons/ButtonSecondary.vue'
import { CSSProperties } from 'vue'
import BuilderComponent, { Row } from './BuilderComponent.vue'

export type ColumnType =
  | 'text'
  | 'color-circle'
  | 'button'
  | 'divider'
  | 'component'
  | 'image'
  | 'builder'

export type ColumnPropsT<Type extends ColumnType> = Type extends 'text'
  ? TextBaseProps
  : Type extends 'divider'
  ? {}
  : Type extends 'component'
  ? {
      is: string
    }
  : Type extends 'builder'
  ? {
      rows: Row[]
    }
  : Type extends 'image'
  ? {
      src: string
    }
  : Type extends 'color-circle'
  ? {
      color: string
    }
  : Type extends 'button'
  ? {
      label: string
      size: 'small' | 'medium' | 'large'
      palette: 'primary' | 'secondary' | 'success' | 'warning' | 'error'
      tabIndex?: number
      emit: string
    }
  : never

type ColumnAdditional = {
  style?: CSSProperties
}

type PropType<Type extends ColumnType> = {
  type: Type
  props: ColumnPropsT<Type>
}

export type ColumnT<Type extends ColumnType> = (Type extends 'text'
  ? PropType<'text'>
  : Type extends 'color-circle'
  ? PropType<'color-circle'>
  : Type extends 'button'
  ? PropType<'button'>
  : Type extends 'divider'
  ? PropType<'divider'>
  : Type extends 'component'
  ? PropType<'component'>
  : Type extends 'builder'
  ? PropType<'builder'>
  : Type extends 'image'
  ? PropType<'image'>
  : never) &
  ColumnAdditional

export type Column = ColumnT<ColumnType>

type Props = {
  col: Column
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderColumn',
  props: {
    col: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "builder-component-col",
    style: _normalizeStyle(_ctx.col.style)
  }, [
    (_ctx.col.type === 'text')
      ? (_openBlock(), _createBlock(TextBase, _normalizeProps(_mergeProps({ key: 0 }, _ctx.col.props)), null, 16))
      : (_ctx.col.type === 'button')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.col.props.palette === 'primary')
              ? (_openBlock(), _createBlock(ButtonPrimary, {
                  key: 0,
                  size: _ctx.col.props.size,
                  class: "button",
                  buttonText: _ctx.col.props.label,
                  tabIndex: _ctx.col.props.tabIndex,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(_ctx.col.props.emit)))
                }, null, 8, ["size", "buttonText", "tabIndex"]))
              : (_ctx.col.props.palette === 'secondary')
                ? (_openBlock(), _createBlock(ButtonSecondary, {
                    key: 1,
                    size: _ctx.col.props.size,
                    class: "button",
                    buttonText: _ctx.col.props.label,
                    tabIndex: _ctx.col.props.tabIndex,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(_ctx.col.props.emit)))
                  }, null, 8, ["size", "buttonText", "tabIndex"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, "Button not implemented"))
          ], 64))
        : (_ctx.col.type === 'color-circle')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "color-circle",
              style: _normalizeStyle({ backgroundColor: _ctx.col.props.color })
            }, null, 4))
          : (_ctx.col.type === 'divider')
            ? (_openBlock(), _createBlock(DividerHorizontal, { key: 3 }))
            : (_ctx.col.type === 'component')
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.col.props.is), { key: 4 }))
              : (_ctx.col.type === 'image')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 5,
                    class: "image",
                    src: _ctx.col.props.src
                  }, null, 8, _hoisted_2))
                : (_ctx.col.type === 'builder')
                  ? (_openBlock(), _createBlock(BuilderComponent, _mergeProps({
                      key: 6,
                      rows: _ctx.col.props.rows
                    }, _ctx.$attrs), null, 16, ["rows"]))
                  : _createCommentVNode("", true)
  ], 4))
}
}

})